export const track_config = {
	production: {
		url: "//corgi-track.qa.cast.org/",
		siteId: 2
	},
	development: {
		url: "//corgi-track.qa.cast.org/",
		siteId: 1
	}
}